import { useTranslation } from 'react-i18next'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import TransactionDetailCardSkeleton from './TransactionDetailCardSkeleton/TransactionDetailCardSkeleton'
import TransactionDetailMenu from './TransactionDetailMenu/TransactionDetailMenu'
import TransactionDetails from './TransactionDetails/TransactionDetails'

const TransactionDetailCard = ({
  loading,
  data,
  onChangeStatus,
  onIssueRefund,
  onCancelStoreCredit,
  onCancelGiftCard,
  disabledIssueRefund,
  onPutRefundOnHold,
  allowPutRefundOnHold,
  allowsResendPaymentLink,
  onResendPaymentLink,
  allowRevertCancelStatus,
  disabledRevertCancelStatus,
  onRevertCancelStatus,
  customersUrl,
  onClickCustomersUrl,
  onSwitchExchangeToRefund,
  allowSwitchExchangeToRefund,
  onMarkAsIssued,
  allowMarkAsIssued,
  allowCancelStoreCredit,
  allowCancelGiftCard,
  onAmendRejected,
  disabledAmendRejected,
  onMarkAsPaid,
  allowMarkAsPaid,
  tags,
  onChangeTags,
}) => {
  const { t } = useTranslation()

  if (loading) return <TransactionDetailCardSkeleton />

  return (
    <>
      <Card showBorder={false}>
        <CardTitle>
          {t('Transacción')}
          <TransactionDetailMenu
            onIssueRefund={onIssueRefund}
            onCancelStoreCredit={onCancelStoreCredit}
            onCancelGiftCard={onCancelGiftCard}
            disabledIssueRefund={disabledIssueRefund}
            onPutRefundOnHold={onPutRefundOnHold}
            allowPutRefundOnHold={allowPutRefundOnHold}
            onAmendRejected={onAmendRejected}
            disabledAmendRejected={disabledAmendRejected}
            allowsResendPaymentLink={allowsResendPaymentLink}
            onResendPaymentLink={onResendPaymentLink}
            allowRevertCancelStatus={allowRevertCancelStatus}
            disabledRevertCancelStatus={disabledRevertCancelStatus}
            onRevertCancelStatus={onRevertCancelStatus}
            customersUrl={customersUrl}
            onClickCustomersUrl={onClickCustomersUrl}
            onSwitchExchangeToRefund={onSwitchExchangeToRefund}
            allowSwitchExchangeToRefund={allowSwitchExchangeToRefund}
            onMarkAsIssued={onMarkAsIssued}
            allowMarkAsIssued={allowMarkAsIssued}
            allowCancelStoreCredit={allowCancelStoreCredit}
            allowCancelGiftCard={allowCancelGiftCard}
            onMarkAsPaid={onMarkAsPaid}
            allowMarkAsPaid={allowMarkAsPaid}
          />
        </CardTitle>
        <TransactionDetails
          onChangeStatus={status =>
            onChangeStatus({
              orderId: data?.id,
              status,
              issueRefundAtStatus: data?.issue_refund_at_status,
              allowsIssueRefund: data?.permissions?.allows_issue_refund,
              issueExchangeAtStatus: data?.issue_exchange_at_status,
              allowsExchangeOrderProcessing: data?.permissions?.allows_exchange_order_processing,
            })
          }
          availableStatus={data?.available_status}
          status={data?.status}
          transactionType={data?.transaction_type}
          isInstant={data?.is_instant}
          isCoveredByReturnProtection={data?.is_covered_by_return_protection}
          completedAt={data?.completed_at}
          modified={data?.modified}
          amount={data?.summary?.summary_total_amount}
          currency={data?.summary?.currency}
          paymentStatus={data?.summary?.payment_status}
          paymentAmount={data?.summary?.payment_amount}
          refundStatus={data?.summary?.refund_status}
          refundAmount={data?.summary?.refund_amount}
          refundMethod={data?.refund_info?.refund_method}
          summaryStatus={data?.summary?.status}
          pendingAmount={data?.summary?.pending_amount}
          exchangedForOrder={data?.exchanged_for_order}
          exchangeForOrderNumber={data?.exchanged_for_order?.name}
          exchangedForOrderExternalUrl={data?.exchanged_for_order?.external_url}
          adjustments={data?.refund_info?.adjustment_refunds}
          onIssueRefund={onIssueRefund}
          onCancelStoreCredit={onCancelStoreCredit}
          onCancelGiftCard={onCancelGiftCard}
          disabledIssueRefund={disabledIssueRefund}
          onPutRefundOnHold={onPutRefundOnHold}
          allowPutRefundOnHold={allowPutRefundOnHold}
          issueExchangeAtStatus={data?.issue_exchange_at_status}
          remainingAmount={data?.summary?.remaining_amount}
          onMarkAsIssued={onMarkAsIssued}
          allowMarkAsIssued={allowMarkAsIssued}
          allowCancelStoreCredit={allowCancelStoreCredit}
          allowCancelGiftCard={allowCancelGiftCard}
          storeId={data?.store_id}
          customerReviewRating={data?.customer_details?.customer_review_rating}
          onMarkAsPaid={onMarkAsPaid}
          allowMarkAsPaid={allowMarkAsPaid}
          tags={tags}
          onChangeTags={onChangeTags}
        />
      </Card>
    </>
  )
}

export default TransactionDetailCard
